<template>
  <div ref="ask" class="plv-ia-qa-ask">
    <div
      class="plv-ia-qa-ask__main pws-que-bg-color pws-iar-pc-qa-ask"
      :class="{ 'plv-ia-qa-ask__main--more': emotionsVisible }"
    >
      <div class="plv-ia-qa-ask__ctrl pws-aside-bg-color pws-iar-pc-qa-ask-input">
        <div class="plv-ia-qa-ask-input__wrap">
          <textarea
            ref="input"
            v-model.trim="askContent"
            :placeholder="iarTrans('questionAnswer.askPlaceholder')"
            :maxlength="maxLen"
            class="plv-ia-qa-ask-input pws-aside-bg-color pws-que-input-text-color pws-chat-scroll-color pws-iar-pc-qa-ask-input-textarea"
            @keyup.enter.exact="handleReply"
            @keyup.shift.enter="handleAddLineBreak"
          ></textarea>
        </div>
        <button
          v-if="faceEmotionEnabled"
          class="plv-ia-qa-ask-emotion iconfont-pc g-icon-pc-emotion pws-que-pc-emotion pws-iar-pc-qa-ask-emotion-icon"
          @click="toggleEmotions"
        ></button>
        <button
          class="plv-ia-qa-ask-send pws-que-pc-send-btn-bg-color pws-que-send-btn-text-color pws-iar-pc-qa-ask-send-button"
          :class="{
            'is-disabled': !canReply,
          }"
          :disabled="!canReply"
          @click="handleReply"
        >
          {{ iarTrans('questionAnswer.send') }}
        </button>
      </div>
      <emotions
        v-if="faceEmotionEnabled"
        :key="lang"
        ref="emotions"
        :visible="emotionsVisible"
        :lang="lang"
        @add="handleEmotionAdd"
      />
    </div>
  </div>
</template>

<script>
import { isParent } from '@/assets/utils/dom.js';
import { emotionsReady, LangType } from '@polyv/emotion-sdk';
import Emotions from '../Emotions/PcEmotions';
import basicMixin from '../../../assets/mixins/basic';
import { BEFORE_DESTROY } from '@/assets/utils/compat';
import mixin from './mixin';

export default {
  components: {
    emotions: Emotions,
  },
  mixins: [basicMixin, mixin],
  props: {
    maxLen: {
      type: Number,
      default: 500
    },
    faceEmotionEnabled: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    canReply() {
      return this.askContent !== '';
    },
  },

  mounted() {
    document.addEventListener('click', this.hideEmotions);
  },

  [BEFORE_DESTROY]() {
    document.removeEventListener('click', this.hideEmotions);
  },

  methods: {
    hideEmotions(e) {
      if (!this.$refs.emotions) return;
      if (!isParent(e.target, this.$refs.emotions.$el)) {
        this.emotionsVisible = false;
      }
    },

    toggleEmotions(e) {
      e.stopPropagation();
      this.emotionsVisible = !this.emotionsVisible;
    },

    handleReply() {
      if (!this.askContent) return;
      emotionsReady((parser) => {
        this.$emit('send', parser.translate(this.askContent, LangType.ZH_CN));
        this.askContent = '';
      });
    },

    // 换行
    handleAddLineBreak() {
      this.askContent += '\n';
    },

    // 选择表情
    handleEmotionAdd(val) {
      this.askContent += `[${val}]`;
      this.emotionsVisible = false;
    },
  }
};
</script>
